export type Platform = 'mac' | 'other';

const APPLE = /Mac|iPhone|iPad|iPod/i;

/**
 * Detects Apple platforms (⌘ is the primary modifier there). `navigator.platform` names the real
 * OS (iPadOS reports "MacIntel"); the user agent is only a fallback – WebKit on Linux, for
 * example, sends a Mac user agent but has Ctrl as its modifier.
 */
export function detectPlatform(
  nav: { platform?: string; userAgent?: string } | undefined,
): Platform {
  if (!nav) return 'other';
  const platform = nav.platform?.trim() ?? '';
  return APPLE.test(platform !== '' ? platform : (nav.userAgent ?? '')) ? 'mac' : 'other';
}

export function currentPlatform(): Platform {
  return detectPlatform(typeof navigator === 'undefined' ? undefined : navigator);
}
